import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Shipping from './features/shipping/Shipping';
import Finance from './features/finance/Finance';
import MecCloseChecklist from './features/finance/MecCloseChecklist';
import SignIn from './features/auth/SignIn';
import ForgotPassword from './features/auth/ForgotPassword';
import ResetPassword from './features/auth/ResetPassword';
import 'react-toastify/dist/ReactToastify.css'
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, Slide } from 'react-toastify';
import { ROLES, ROUTES } from './consts/general';
import { checkAuthStatusAsync } from './slices/authSlice';
import Vendors from './features/management/vendors/Vendors';
import ErrorBoundary from './utils/ErrorBoundary';
import { Navigate } from 'react-router-dom';
import DisconnectQB from './features/auth/DisconnectQB';
import QBReport from './features/qbReport/QBReport';
import Sidebar from './components/Sidebar';
import { demandPlanningPath } from './components/Sidebar/const';
import { useIsMobile } from './helpers/useIsMobile';
import { isInEadinApp, rememberAppPage, appHomePath, APP_PATHS } from './helpers/inEadinApp';
import InAppBar from './components/InAppBar';
import AppHandoff, { APP_HANDOFF_PATH } from './features/auth/AppHandoff';
import ProductCost from './features/productCost/ProductCost';
import Cron from './features/cron/Cron';
import Products from './features/inventory/Products';
import PurchaseOrders from './features/purchaseOrders/PurchaseOrders';
import Orders from './features/orders/Orders';
import Notes from './features/notes/Notes';
import KlaviyoAnalytics from './features/marketing/KlaviyoAnalytics';
import ReportDashboard from './features/reports/ReportDashboard';
import CustomReport from './features/reports/CustomReport';
import SalesByProductReport from './features/reports/SalesByProductReport';
import SalesByProductByDayReport from './features/reports/SalesByProductByDayReport';
import PaymentReport from './features/reports/PaymentReport';
import BillcomPoReconciliationReport from './features/reports/BillcomPoReconciliationReport';
import BillcomApWritebackStatusReport from './features/reports/BillcomApWritebackStatusReport';
import BillcomBankCashReconReport from './features/reports/BillcomBankCashReconReport';
import SalesRevenueReport from './features/reports/SalesRevenueReport';
import SalesRevenueMonthlyReport from './features/reports/SalesRevenueMonthlyReport';
import InboundShipmentsReport from './features/reports/InboundShipmentsReport';
import InboundShipmentsOverviewReport from './features/reports/InboundShipmentsOverviewReport';
import ShopifyProfitSummaryReport from './features/reports/ShopifyProfitSummaryReport';
import ShopifyProfitBySkuSummaryReport from './features/reports/ShopifyProfitBySkuSummaryReport';
import AmazonProfitByProductSummaryReport from './features/reports/AmazonProfitByProductSummaryReport';
import AmazonProfitBySkuSummaryReport from './features/reports/AmazonProfitBySkuSummaryReport';
import { PurchaseOrderPaymentSchedule } from './features/reports/PurchaseOrderPaymentSchedule';
import { PurchaseOrderPaymentProgress } from './features/reports/PurchaseOrderPaymentProgress';
import TotalProductRevenueReport from './features/reports/TotalProductRevenueReport';
import ExistedSkus from './features/finance/ExistedSkus';
import InactiveSkus from './features/finance/InactiveSkus';
import MonthlyInboundShipmentsValues from './features/reports/MonthlyInboundShipmentsValues';
import ReceivedShipmentsReports from './features/reports/ReceivedShipmentsReports';
import WarehouseInventoryValueReport from './features/reports/WarehouseInventoryValueReport';
import WarehouseReconciliationReport from './features/reports/WarehouseReconciliationReport';
import BinRestockingReport from './features/reports/BinRestockingReport';
import PickPackReport from './features/reports/PickPackReport';
import InboundGetReadyReport from './features/reports/InboundGetReadyReport';
import InboundReceivingPutawayReport from './features/reports/InboundReceivingPutawayReport';
import AmazonMonthEndCloseSummaryReport from './features/reports/AmazonMonthEndCloseSummaryReport';
import InventoryCostChangeReport from './features/reports/InventoryCostChangeReport';
import DemandPlanningChangeLogReport from './features/reports/DemandPlanningChangeLogReport';
import DailyChannelMetricsReport from './features/reports/DailyChannelMetricsReport';
import DailySummaryReport from './features/reports/DailySummaryReport';
import SkuAllocationChangeLogReport from './features/reports/SkuAllocationChangeLogReport';
import ShippingEachCostChangeReport from './features/reports/ShippingEachCostChangeReport';
import MissingInventoryCostReport from './features/reports/MissingInventoryCostReport';
import SourceSkusByProductReport from './features/reports/SourceSkusByProductReport';
import MaxDiscountPricingReport from './features/reports/MaxDiscountPricingReport';
import EadinCOGS from './features/reports/EadinCOGS';
import EadinCatalog from './features/reports/EadinCatalog';
import EadinInventory from './features/reports/EadinInventory';
import BOMPackaging from './features/reports/BOMPackaging';
import LowStockAlerts from './features/reports/LowStockAlerts';
import AmazonFbaLowStockAlerts from './features/reports/AmazonFbaLowStockAlerts';
import LowStockSoldOutAlerts from './features/reports/LowStockSoldOutAlerts';
import RecentPos from './features/reports/RecentPos';
import AmazonRawInspect from './features/amazonRawInspect/AmazonRawInspect';
import AmazonImportsReport from './features/reports/AmazonImportsReport';
import AmazonTransactionDetailReport from './features/reports/AmazonTransactionDetailReport';
import AmazonPLSummaryReport from './features/reports/AmazonPLSummaryReport';
import AmazonAdSpendDetailReport from './features/reports/AmazonAdSpendDetailReport';
import FedexBillingReconciliationReport from './features/reports/FedexBillingReconciliationReport';
import { ShipheroLabelCostReport, PackagingUsageReport } from './features/reports/ShipheroMonthlyCostReport';
import QboChangeLedgerReport from './features/reports/QboChangeLedgerReport';
import PoLedgerShadowReport from './features/reports/PoLedgerShadowReport';
import PoStatusAuditReport from './features/reports/PoStatusAuditReport';
import BillcomPoBalanceReconciliationReport from './features/reports/BillcomPoBalanceReconciliationReport';
import MonthEndInventoryReport from './features/reports/MonthEndInventoryReport';
import AmazonReconciliationExceptionsReport from './features/reports/AmazonReconciliationExceptionsReport';
import Budget from './features/qbReport/Budget';
import CommandCenterRedirect from './features/analytics/CommandCenterRedirect';
import MerchandisingRedirect from './features/analytics/MerchandisingRedirect';
import DuplicatesReports from './features/finance/DuplicatesReports';
import Forecast from './features/qbReport/Forecast';
import FinancialChat from './features/chat/FinancialChat';
import PrintLabelSettings from './features/shipping/PrintLabelSettings';
import { UsersSettings } from './features/management/users/UsersSettings';
// import InventoryByShopifyAndAmazon from './features/inventory/InventoryByShopifyAndAmazon';
import { 
  CHILDREN_TAB_ACCOUNTS_PAYABLE, 
  CHILDREN_TAB_APP_NOTES, 
  CHILDREN_TAB_KLAVIYO_ANALYTICS,
  CHILDREN_TAB_TRYBE_CONTEST,
  CHILDREN_TAB_NOTIFICATION_SETTINGS,
  CHILDREN_TAB_BUDGET_X_FORECAST, 
  CHILDREN_TAB_CATALOG, 
  CHILDREN_TAB_CRON, 
  CHILDREN_TAB_FINANCE_CHAT, 
  CHILDREN_TAB_FORECAST_PLANNING_SYSTEM, 
  CHILDREN_TAB_HOURLY_PERFORMANCE, 
  CHILDREN_TAB_ORDERS, 
  CHILDREN_TAB_PRODUCTS, 
  CHILDREN_TAB_CASH_FLOW, 
  CHILDREN_TAB_PROFIT_AND_LOSS, 
  CHILDREN_TAB_PURCHASE_ORDERS, 
  CHILDREN_TAB_RECEIVED_BOXES, 
  CHILDREN_TAB_REPORTS, 
  CHILDREN_TAB_AMAZON_PROFIT_BY_PRODUCT,
  CHILDREN_TAB_PICK_PACK_REPORT,
  CHILDREN_TAB_MONTH_END_INVENTORY,
  CHILDREN_TAB_AMAZON_FBA_LOW_STOCK_ALERTS,
  CHILDREN_TAB_INBOUND_RECEIVING_PUTAWAY,
  CHILDREN_TAB_RETURNS_RECEIVING,
  CHILDREN_TAB_RETURNS_PROCESSING_REPORT,
  CHILDREN_TAB_AMAZON_PROFIT_BY_SKU,
  CHILDREN_TAB_SHIPMENTS, 
  CHILDREN_TAB_STOCK_LEVELS, 
  CHILDREN_TAB_SUPPLIERS, 
  CHILDREN_TAB_USERS, 
  CHILDREN_TAB_BALANCE_SHEET, 
  CHILDREN_TAB_PRODUCTS_CATALOG,
  CHILDREN_TAB_MERCHANDISING_KPIS,
  CHILDREN_TAB_SKU_MAPPING, 
  CHILDREN_TAB_BOM, 
  CHILDREN_TAB_INVENTORY_RECLASSIFY,
  CHILDREN_TAB_DEMAND_PLANNING, 
  CHILDREN_TAB_COGS_CANONICAL_VIEW, 
  CHILDREN_TAB_EFFECTIVE_CAPITAL_SUMMARY,
  CHILDREN_TAB_THIRTEEN_WEEK_CASH_FLOW,
  CHILDREN_TAB_MEC_CLOSE_CHECKLIST,
  isAdminRole
} from './consts/management/users/users';
import Received from './features/received/Received';
import ReceivedLog from './features/received/ReceivedLog';
import ReceivedSessions from './features/received/ReceivedSessions';
import WarehousePage from './features/warehouse/WarehousePage';
import InventoryLedgerReport from './features/reports/InventoryLedgerReport';
import AmazonFbaTransferLedgerReport from './features/reports/AmazonFbaTransferLedgerReport';
import AmazonFbaTransferHistoryReport from './features/reports/AmazonFbaTransferHistoryReport';
import FbaTransfers from './features/fbaTransfers/FbaTransfers';
import AmazonFbaInventory from './features/amazonFbaInventory/AmazonFbaInventory';
import InventoryTransfers from './features/inventoryTransfers/InventoryTransfers';
import ReturnsReceiving from './features/returns/ReturnsReceiving';
import ReturnsProcessingReport from './features/reports/ReturnsProcessingReport';
import { getLocationsOfReports } from './slices/reportsSlice';
import { AMAZON_PROFIT_BY_SKU_SUMMARY, AMAZON_PROFIT_SUMMARY, AMAZON_IMPORTS, AMAZON_TRANSACTION_DETAIL, AMAZON_PL_SUMMARY, AMAZON_AD_SPEND_DETAIL, AMAZON_RECONCILIATION_EXCEPTIONS, AMAZON_MONTH_END_CLOSE_SUMMARY, BIN_RESTOCKING_BRIEF, PICK_PACK_REPORT, BILLCOM_AP_WRITEBACK_STATUS, INBOUND_GET_READY, INBOUND_RECEIVING_PUTAWAY, RETURNS_PROCESSING, BILLCOM_BANK_CASH_RECON, BILLCOM_PO_BALANCE_RECONCILIATION, MONTH_END_INVENTORY, BILLCOM_PO_RECONCILIATION, BOM_PACKAGING, CLOSED_PO_RECONCILIATION, DAILY_CHANNEL_METRICS, DAILY_SUMMARY, DATA_RECONCILIATION, DEMAND_PLANNING_CHANGE_LOG, EADIN_CATALOG, EADIN_INVENTORY, EADIN_COGS, FEDEX_BILLING_RECONCILIATION, SHIPHERO_LABEL_COST, PACKAGING_USAGE, QBO_CHANGE_LEDGER, INVENTORY_LEDGER, AMAZON_FBA_TRANSFER_LEDGER, AMAZON_FBA_TRANSFER_HISTORY, INBOUND_SHIPMENTS, INBOUND_SHIPMENTS_OVERVIEW, INVENTORY_COST_CHANGE, KLAVIYO_CAMPAIGN_PERFORMANCE, KLAVIYO_CAMPAIGNS, KLAVIYO_FLOW_PERFORMANCE, KLAVIYO_FLOWS, KLAVIYO_LISTS, KLAVIYO_METRIC_AGGREGATES, KLAVIYO_METRICS, KLAVIYO_SEGMENTS, LOW_STOCK_ALERTS, AMAZON_FBA_LOW_STOCK_ALERTS, LOW_STOCK_SOLD_OUT_ALERTS, META_ADS, META_INSIGHTS, MISSING_INVENTORY_COST, MONTHLY_AP_PO_PAID, MONTHLY_INBOUND_SHIPMENTS_VALUES, MONTHLY_PO_AP_DUE, MONTHLY_PO_AP_PROGRESS, PO_LEDGER_SHADOW, PO_STATUS_AUDIT, RECEIVED_SHIPMENTS_REPORTS, RECENT_POS, SALES_BY_PRODUCT, SALES_BY_PRODUCT_BY_DAY, SALES_REVENUE, SALES_REVENUE_MONTHLY, SHIPPING_EACH_COST_CHANGE, SHOPIFY_PROFIT_BY_SKU_SUMMARY, SHOPIFY_PROFIT_SUMMARY, SKU_ALLOCATION_CHANGE_LOG, SOURCE_SKUS_BY_PRODUCT, MAX_DISCOUNT_PRICING, TOTAL_PRODUCT_REVENUE, WAREHOUSE_INVENTORY_VALUE, WAREHOUSE_RECONCILIATION } from './consts/reports';
import BudgetForecast from './features/qbReport/BudgetForecast';
import ForecastPlanningSystem from './features/planning/ForecastPlanningSystem';
import DownloadPage from './pages/DownloadPage';
import NotificationSettings from './features/notifications/NotificationSettings';
import Notifications from './features/notifications/Notifications';
import InventoryByShopifyAndAmazonCalculation from './features/inventory/InventoryByShopifyAndAmazonCalculation';
import ProfitAndLossNew from './features/qbReport/ProfitAndLossNew';
import CashFlow from './features/qbReport/CashFlow';
import { requestManager } from './helpers/requestManager';
import BalanceSheet from './features/qbReport/BalanceSheet';
import { getAllowedUserPermissions } from './helpers/common';
import ProductCatalog from './features/productCost/ProductCatalog';
import SKUMapping from './features/productCost/SKUMapping';
import BOM from './features/productCost/BOM';
import InventoryReclassify from './features/inventoryReclassify/InventoryReclassify';
import DemandPlanning from './features/planning/DemandPlanning';
import COGSCanonicalView from './features/finance/COGSCanonicalView';
import TestSuppliers from './features/management/vendors/Vendors';
import EffectiveCapitalSummary from './features/finance/EffectiveCapitalSummary';
import ThirteenWeekCashFlow from './features/finance/ThirteenWeekCashFlow';
import { getPermissionCatalog, getPermissionRouteAliases } from './components/Sidebar/const';
import MetaInsightsReport from './features/reports/MetaInsightsReport';
import TrybeContest from './features/marketing/TrybeContest';
import MetaAdsReport from './features/reports/MetaAdsReport';
import DataReconciliation from './features/reports/DataReconciliation';
import KlaviyoCampaignsReport from './features/reports/KlaviyoCampaignsReport';
import KlaviyoCampaignPerformanceReport from './features/reports/KlaviyoCampaignPerformanceReport';
import KlaviyoFlowsReport from './features/reports/KlaviyoFlowsReport';
import KlaviyoFlowPerformanceReport from './features/reports/KlaviyoFlowPerformanceReport';
import KlaviyoListsReport from './features/reports/KlaviyoListsReport';
import KlaviyoSegmentsReport from './features/reports/KlaviyoSegmentsReport';
import KlaviyoMetricsReport from './features/reports/KlaviyoMetricsReport';
import KlaviyoMetricAggregatesReport from './features/reports/KlaviyoMetricAggregatesReport';
import Landing from './features/marketing/Landing';
import NotFoundPage from './components/NotFoundPage';
import { reportClientEvent } from './helpers/clientLog';

function AppContent({ 
  isSidebarOpen, 
  setIsSidebarOpen, 
  isSmallScreen, 
  loading,
  currentUser, 
  locationsOfReports 
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const isSignIn = location.pathname === '/signin';
  const isLanding = location.pathname === '/';
  const isDownloadPage = location.pathname.startsWith('/downloads/');
  const isPasswordReset = location.pathname === '/forgot-password' || location.pathname === '/reset-password';
  const inApp = isInEadinApp();
  const isAppHandoff = location.pathname === APP_HANDOFF_PATH;
  const authedRedirect = (to) => (!loading && currentUser ? <Navigate to={to} replace /> : null);

  useEffect(() => {
    requestManager.reset();
  }, [location.pathname]);

  const userPermissions = currentUser?.permissions || [];
  const isMobile = useIsMobile();
  const OPEN_WIDTH = 300;
  const COLLAPSED_WIDTH = 50;
  // Use a stable effective value during initial render: open on desktop, closed on small screens
  const effectiveSidebarOpen = (isSidebarOpen === undefined) ? !isSmallScreen : isSidebarOpen;
  const sidebarWidthPx = isMobile ? 0 : (effectiveSidebarOpen ? OPEN_WIDTH : COLLAPSED_WIDTH);
  const marginFromSidebar = (isSignIn || isLanding || isDownloadPage || isPasswordReset) ? '' : `ml-[${sidebarWidthPx}px]`;
  const mainBlockWidth = (isSignIn || isLanding || isDownloadPage || isPasswordReset) ? 'w-[100%]' : `w-[calc(100%-${sidebarWidthPx}px)]`;
  const replacedMargin = String(sidebarWidthPx);
  const mainInlineStyle = (inApp || isSignIn || isLanding || isDownloadPage || isPasswordReset)
    ? { width: '100%' }
    : isMobile
      ? { width: '100%', paddingTop: '56px' }
      : { marginLeft: `${sidebarWidthPx}px`, width: `calc(100% - ${sidebarWidthPx}px)` };

  useEffect(() => {
    if (inApp) rememberAppPage(location.pathname);
  }, [inApp, location.pathname]);

  useEffect(() => {
    if (inApp && !loading && currentUser && !isSignIn && !isAppHandoff && !APP_PATHS.includes(location.pathname)) {
      navigate(appHomePath(), { replace: true });
    }
  }, [inApp, loading, currentUser, isSignIn, isAppHandoff, location.pathname, navigate]);

  useEffect(() => {
    if (!loading && !currentUser && !isSignIn && !isAppHandoff && !isLanding && !isDownloadPage && !isPasswordReset) {
      reportClientEvent('auth_redirect_to_signin', { from: `${location.pathname}${location.search}` });
      navigate('/signin', { replace: true });
    }
  }, [loading, currentUser, isSignIn, isAppHandoff, isLanding, isDownloadPage, isPasswordReset, navigate, location.pathname, location.search]);

  const routes = [
    { id: CHILDREN_TAB_ACCOUNTS_PAYABLE, path: ROUTES.FINANCE, Component: Finance },
    { id: CHILDREN_TAB_PROFIT_AND_LOSS, path: ROUTES.PROFIT_AND_LOSS, Component: ProfitAndLossNew },
    { id: CHILDREN_TAB_BALANCE_SHEET, path: ROUTES.BALANCE_SHEET, Component: BalanceSheet },
    { id: CHILDREN_TAB_CASH_FLOW, path: ROUTES.CASH_FLOW, Component: CashFlow },
    { id: CHILDREN_TAB_MEC_CLOSE_CHECKLIST, path: ROUTES.MEC_CLOSE_CHECKLIST, Component: MecCloseChecklist },
    { id: CHILDREN_TAB_COGS_CANONICAL_VIEW, path: ROUTES.COGS_CANONICAL_VIEW, Component: COGSCanonicalView },
    { id: CHILDREN_TAB_BUDGET_X_FORECAST, path: ROUTES.BUDGET, Component: Budget },
    { id: CHILDREN_TAB_EFFECTIVE_CAPITAL_SUMMARY, path: ROUTES.EFFECTIVE_CAPITAL_SUMMARY, Component: EffectiveCapitalSummary },
    { id: CHILDREN_TAB_THIRTEEN_WEEK_CASH_FLOW, path: ROUTES.THIRTEEN_WEEK_CASH_FLOW, Component: ThirteenWeekCashFlow },
    { id: CHILDREN_TAB_BUDGET_X_FORECAST, path: ROUTES.FORECAST, Component: Forecast },
    { id: CHILDREN_TAB_FORECAST_PLANNING_SYSTEM, path: ROUTES.FORECAST_PLANNING_SYSTEM, Component: ForecastPlanningSystem },
    { id: CHILDREN_TAB_DEMAND_PLANNING, path: ROUTES.DEMAND_PLANNING, Component: DemandPlanning },
    
    { id: CHILDREN_TAB_FINANCE_CHAT, path: ROUTES.FINANCE_CHAT, Component: FinancialChat },
    { id: CHILDREN_TAB_BUDGET_X_FORECAST, path: ROUTES.BUDGET_X_FORECAST, Component: BudgetForecast },
    { id: CHILDREN_TAB_HOURLY_PERFORMANCE, path: ROUTES.ANALYTICS_TRIPLEWHALE, Component: CommandCenterRedirect },
    { id: CHILDREN_TAB_KLAVIYO_ANALYTICS, path: ROUTES.KLAVIYO_ANALYTICS, Component: KlaviyoAnalytics },
    { id: CHILDREN_TAB_TRYBE_CONTEST, path: ROUTES.TRYBE_CONTEST, Component: TrybeContest },
    
    { id: CHILDREN_TAB_SHIPMENTS, path: ROUTES.SHIPPING, Component: Shipping },
    { id: CHILDREN_TAB_ORDERS, path: ROUTES.ORDERS, Component: Orders },
    { id: CHILDREN_TAB_PURCHASE_ORDERS, path: ROUTES.PURCHASE_ORDERS, Component: PurchaseOrders },
    { id: CHILDREN_TAB_PURCHASE_ORDERS, path: `${ROUTES.PURCHASE_ORDERS}/:poRef`, Component: PurchaseOrders },
    { id: CHILDREN_TAB_RECEIVED_BOXES, path: ROUTES.RECEIVED, Component: Received },

    // { id: CHILDREN_TAB_STOCK_LEVELS, path: ROUTES.SHOPIFY_AMAZON_INVENTORY, Component: InventoryByShopifyAndAmazon },
    { id: CHILDREN_TAB_STOCK_LEVELS, path: ROUTES.SHOPIFY_AMAZON_INVENTORY, Component: InventoryByShopifyAndAmazonCalculation },
    { id: CHILDREN_TAB_PRODUCTS, path: ROUTES.PRODUCTS, Component: Products },
    { id: CHILDREN_TAB_CATALOG, path: ROUTES.CATALOG, Component: ProductCost },
    { id: CHILDREN_TAB_PRODUCTS_CATALOG, path: ROUTES.PRODUCTS_CATALOG, Component: ProductCatalog },
    { id: CHILDREN_TAB_MERCHANDISING_KPIS, path: ROUTES.MERCHANDISING_KPIS, Component: MerchandisingRedirect },
    { id: CHILDREN_TAB_SKU_MAPPING, path: ROUTES.SKU_MAPPING, Component: SKUMapping },
    { id: CHILDREN_TAB_BOM, path: ROUTES.BOM, Component: BOM },
    { id: CHILDREN_TAB_INVENTORY_RECLASSIFY, path: ROUTES.INVENTORY_RECLASSIFY, Component: InventoryReclassify },

    { id: CHILDREN_TAB_SUPPLIERS, path: ROUTES.VENDORS, Component: Vendors },

    { id: CHILDREN_TAB_REPORTS, path: ROUTES.REPORTS, Component: ReportDashboard },

    { id: CHILDREN_TAB_USERS, path: ROUTES.USERS_SETTINGS, Component: UsersSettings },
    { id: CHILDREN_TAB_CRON, path: ROUTES.CRON, Component: Cron },
    { id: CHILDREN_TAB_APP_NOTES, path: ROUTES.NOTES, Component: Notes },
    { id: CHILDREN_TAB_NOTIFICATION_SETTINGS, path: ROUTES.NOTIFICATIONS_SETTINGS, Component: NotificationSettings },
  ];

  const filteredReports = [
    { id: SALES_BY_PRODUCT, path: ROUTES.REPORTS_SALES_BY_PRODUCT, Component: SalesByProductReport },
    { id: MONTHLY_INBOUND_SHIPMENTS_VALUES, path: ROUTES.REPORTS_MONTHLY_INBOUND_SHIPMENTS_VALUES, Component: MonthlyInboundShipmentsValues },
    { id: RECEIVED_SHIPMENTS_REPORTS, path: ROUTES.REPORTS_RECEIVED_SHIPMENTS_REPORTS, Component: ReceivedShipmentsReports },
    { id: WAREHOUSE_INVENTORY_VALUE, path: ROUTES.REPORTS_WAREHOUSE_INVENTORY_VALUE, Component: WarehouseInventoryValueReport },
    { id: WAREHOUSE_RECONCILIATION, path: ROUTES.REPORTS_WAREHOUSE_RECONCILIATION, Component: WarehouseReconciliationReport },
    { id: BIN_RESTOCKING_BRIEF, path: ROUTES.REPORTS_BIN_RESTOCKING, Component: BinRestockingReport },
    { id: PICK_PACK_REPORT, path: ROUTES.REPORTS_PICK_PACK, Component: PickPackReport, permissionId: CHILDREN_TAB_PICK_PACK_REPORT },
    { id: INBOUND_GET_READY, path: ROUTES.REPORTS_INBOUND_GET_READY, Component: InboundGetReadyReport },
    { id: INBOUND_RECEIVING_PUTAWAY, path: ROUTES.REPORTS_INBOUND_RECEIVING_PUTAWAY, Component: InboundReceivingPutawayReport, permissionId: CHILDREN_TAB_INBOUND_RECEIVING_PUTAWAY },
    { id: RETURNS_PROCESSING, path: ROUTES.REPORTS_RETURNS_PROCESSING, Component: ReturnsProcessingReport, permissionId: CHILDREN_TAB_RETURNS_PROCESSING_REPORT },
    { id: SALES_BY_PRODUCT_BY_DAY, path: ROUTES.REPORTS_SALES_BY_PRODUCT_BY_DAY, Component: SalesByProductByDayReport },
    { id: MONTHLY_AP_PO_PAID, path: ROUTES.REPORTS_PAYMENT, Component: PaymentReport },
    { id: BILLCOM_PO_RECONCILIATION, path: ROUTES.REPORTS_BILLCOM_PO_RECONCILIATION, Component: BillcomPoReconciliationReport },
    { id: BILLCOM_PO_BALANCE_RECONCILIATION, path: ROUTES.REPORTS_BILLCOM_PO_BALANCE_RECONCILIATION, Component: BillcomPoBalanceReconciliationReport },
    { id: MONTH_END_INVENTORY, path: ROUTES.REPORTS_MONTH_END_INVENTORY, Component: MonthEndInventoryReport, permissionId: CHILDREN_TAB_MONTH_END_INVENTORY },
    { id: PO_LEDGER_SHADOW, path: ROUTES.REPORTS_PO_LEDGER_SHADOW, Component: PoLedgerShadowReport },
    { id: PO_STATUS_AUDIT, path: ROUTES.REPORTS_PO_STATUS_AUDIT, Component: PoStatusAuditReport },
    { id: CLOSED_PO_RECONCILIATION, path: ROUTES.REPORTS_CLOSED_PO_RECONCILIATION, Component: PoStatusAuditReport },
    { id: BILLCOM_AP_WRITEBACK_STATUS, path: ROUTES.REPORTS_BILLCOM_AP_WRITEBACK_STATUS, Component: BillcomApWritebackStatusReport },
    { id: BILLCOM_BANK_CASH_RECON, path: ROUTES.REPORTS_BILLCOM_BANK_CASH_RECON, Component: BillcomBankCashReconReport },
    { id: SALES_REVENUE, path: ROUTES.REPORTS_SALES_REVENUE, Component: SalesRevenueReport },
    { id: SALES_REVENUE_MONTHLY, path: ROUTES.REPORTS_SALES_REVENUE_MONTHLY, Component: SalesRevenueMonthlyReport },
    { id: SHOPIFY_PROFIT_SUMMARY, path: ROUTES.REPORTS_SHOPIFY_PROFIT_SUMMARY, Component: ShopifyProfitSummaryReport },
    { id: SHOPIFY_PROFIT_BY_SKU_SUMMARY, path: ROUTES.REPORTS_SHOPIFY_PROFIT_BY_SKU_SUMMARY, Component: ShopifyProfitBySkuSummaryReport },
    { id: AMAZON_PROFIT_SUMMARY, path: ROUTES.REPORTS_AMAZON_PROFIT_SUMMARY, Component: AmazonProfitByProductSummaryReport, permissionId: CHILDREN_TAB_AMAZON_PROFIT_BY_PRODUCT },
    { id: AMAZON_PROFIT_BY_SKU_SUMMARY, path: ROUTES.REPORTS_AMAZON_PROFIT_BY_SKU_SUMMARY, Component: AmazonProfitBySkuSummaryReport, permissionId: CHILDREN_TAB_AMAZON_PROFIT_BY_SKU },
    { id: MONTHLY_PO_AP_DUE, path: ROUTES.REPORTS_MONTHLY_PO_AP_DUE, Component: PurchaseOrderPaymentSchedule },
    { id: MONTHLY_PO_AP_PROGRESS, path: ROUTES.REPORTS_MONTHLY_PO_AP_PROGRESS, Component: PurchaseOrderPaymentProgress },
    { id: TOTAL_PRODUCT_REVENUE, path: ROUTES.REPORTS_TOTAL_PRODUCT_REVENUE, Component: TotalProductRevenueReport },
    { id: AMAZON_MONTH_END_CLOSE_SUMMARY, path: ROUTES.REPORTS_AMAZON_MONTH_END_CLOSE_SUMMARY, Component: AmazonMonthEndCloseSummaryReport },
    { id: AMAZON_IMPORTS, path: ROUTES.REPORTS_AMAZON_IMPORTS, Component: AmazonImportsReport },
    { id: AMAZON_TRANSACTION_DETAIL, path: ROUTES.REPORTS_AMAZON_TRANSACTION_DETAIL, Component: AmazonTransactionDetailReport },
    { id: AMAZON_PL_SUMMARY, path: ROUTES.REPORTS_AMAZON_PL_SUMMARY, Component: AmazonPLSummaryReport },
    { id: AMAZON_AD_SPEND_DETAIL, path: ROUTES.REPORTS_AMAZON_AD_SPEND_DETAIL, Component: AmazonAdSpendDetailReport },
    { id: AMAZON_RECONCILIATION_EXCEPTIONS, path: ROUTES.REPORTS_AMAZON_RECONCILIATION_EXCEPTIONS, Component: AmazonReconciliationExceptionsReport },
    { id: INBOUND_SHIPMENTS, path: ROUTES.REPORTS_INBOUND_SHIPMENTS, Component: InboundShipmentsReport },
    { id: INBOUND_SHIPMENTS_OVERVIEW, path: ROUTES.REPORTS_INBOUND_SHIPMENTS_OVERVIEW, Component: InboundShipmentsOverviewReport },
    { id: INVENTORY_COST_CHANGE, path: ROUTES.REPORTS_INVENTORY_COST_CHANGE, Component: InventoryCostChangeReport },
    { id: SHIPPING_EACH_COST_CHANGE, path: ROUTES.REPORTS_SHIPPING_EACH_COST_CHANGE, Component: ShippingEachCostChangeReport },
    { id: FEDEX_BILLING_RECONCILIATION, path: ROUTES.REPORTS_FEDEX_BILLING_RECONCILIATION, Component: FedexBillingReconciliationReport },
    { id: SHIPHERO_LABEL_COST, path: ROUTES.REPORTS_SHIPHERO_LABEL_COST, Component: ShipheroLabelCostReport },
    { id: PACKAGING_USAGE, path: ROUTES.REPORTS_PACKAGING_USAGE, Component: PackagingUsageReport },
    { id: QBO_CHANGE_LEDGER, path: ROUTES.REPORTS_QBO_CHANGE_LEDGER, Component: QboChangeLedgerReport },
    { id: INVENTORY_LEDGER, path: ROUTES.REPORTS_INVENTORY_LEDGER, Component: InventoryLedgerReport },
    { id: AMAZON_FBA_TRANSFER_LEDGER, path: ROUTES.REPORTS_AMAZON_FBA_TRANSFER_LEDGER, Component: AmazonFbaTransferLedgerReport },
    { id: AMAZON_FBA_TRANSFER_HISTORY, path: ROUTES.REPORTS_AMAZON_FBA_TRANSFER_HISTORY, Component: AmazonFbaTransferHistoryReport },
    { id: DEMAND_PLANNING_CHANGE_LOG, path: ROUTES.REPORTS_DEMAND_PLANNING_CHANGE_LOG, Component: DemandPlanningChangeLogReport },
    { id: DAILY_CHANNEL_METRICS, path: ROUTES.REPORTS_DAILY_CHANNEL_METRICS, Component: DailyChannelMetricsReport },
    { id: DAILY_SUMMARY, path: ROUTES.REPORTS_DAILY_SUMMARY, Component: DailySummaryReport },
    { id: SKU_ALLOCATION_CHANGE_LOG, path: ROUTES.REPORTS_SKU_ALLOCATION_CHANGE_LOG, Component: SkuAllocationChangeLogReport },
    { id: MISSING_INVENTORY_COST, path: ROUTES.REPORTS_MISSING_INVENTORY_COST, Component: MissingInventoryCostReport },
    { id: SOURCE_SKUS_BY_PRODUCT, path: ROUTES.REPORTS_SOURCE_SKUS_BY_PRODUCT, Component: SourceSkusByProductReport },
    { id: MAX_DISCOUNT_PRICING, path: ROUTES.REPORTS_MAX_DISCOUNT_PRICING, Component: MaxDiscountPricingReport },
    { id: EADIN_COGS, path: ROUTES.REPORTS_EADIN_COGS, Component: EadinCOGS },
    { id: EADIN_CATALOG, path: ROUTES.REPORTS_EADIN_CATALOG, Component: EadinCatalog },
    { id: EADIN_INVENTORY, path: ROUTES.REPORTS_EADIN_INVENTORY, Component: EadinInventory },
    { id: BOM_PACKAGING, path: ROUTES.REPORTS_BOM_PACKAGING, Component: BOMPackaging },
    { id: LOW_STOCK_ALERTS, path: ROUTES.REPORTS_LOW_STOCK_ALERTS, Component: LowStockAlerts },
    { id: AMAZON_FBA_LOW_STOCK_ALERTS, path: ROUTES.REPORTS_AMAZON_FBA_LOW_STOCK_ALERTS, Component: AmazonFbaLowStockAlerts, permissionId: CHILDREN_TAB_AMAZON_FBA_LOW_STOCK_ALERTS },
    { id: LOW_STOCK_SOLD_OUT_ALERTS, path: ROUTES.REPORTS_LOW_STOCK_SOLD_OUT_ALERTS, Component: LowStockSoldOutAlerts },
    { id: RECENT_POS, path: ROUTES.REPORTS_RECENT_POS, Component: RecentPos },
    { id: META_INSIGHTS, path: ROUTES.REPORTS_META_INSIGHTS, Component: MetaInsightsReport },
    { id: META_ADS, path: ROUTES.REPORTS_META_ADS, Component: MetaAdsReport },
    { id: DATA_RECONCILIATION, path: ROUTES.REPORTS_DATA_RECONCILIATION, Component: DataReconciliation },
    { id: KLAVIYO_CAMPAIGNS, path: ROUTES.REPORTS_KLAVIYO_CAMPAIGNS, Component: KlaviyoCampaignsReport },
    { id: KLAVIYO_CAMPAIGN_PERFORMANCE, path: ROUTES.REPORTS_KLAVIYO_CAMPAIGN_PERFORMANCE, Component: KlaviyoCampaignPerformanceReport },
    { id: KLAVIYO_FLOWS, path: ROUTES.REPORTS_KLAVIYO_FLOWS, Component: KlaviyoFlowsReport },
    { id: KLAVIYO_FLOW_PERFORMANCE, path: ROUTES.REPORTS_KLAVIYO_FLOW_PERFORMANCE, Component: KlaviyoFlowPerformanceReport },
    { id: KLAVIYO_LISTS, path: ROUTES.REPORTS_KLAVIYO_LISTS, Component: KlaviyoListsReport },
    { id: KLAVIYO_SEGMENTS, path: ROUTES.REPORTS_KLAVIYO_SEGMENTS, Component: KlaviyoSegmentsReport },
    { id: KLAVIYO_METRICS, path: ROUTES.REPORTS_KLAVIYO_METRICS, Component: KlaviyoMetricsReport },
    { id: KLAVIYO_METRIC_AGGREGATES, path: ROUTES.REPORTS_KLAVIYO_METRIC_AGGREGATES, Component: KlaviyoMetricAggregatesReport },
  ];
  // console.log({ filteredReports, locationsOfReports })
  
  const { allowedChildIds, allowedParentIds, childIdToAccess } = getAllowedUserPermissions({
    permissions: userPermissions,
    permissionRouteAliases: getPermissionRouteAliases(),
    permissionCatalog: getPermissionCatalog(),
    isAdmin: isAdminRole(currentUser?.role),
  });

  const filteredRoutes = routes.filter((route) => allowedChildIds.has(route.id));
  const defaultRedirectPath = filteredRoutes[0]?.path || ROUTES.SHIPPING;

  // Map report id -> [tab_name, ...] from locationsOfReports (CSV supported)
  const reportIdToTabNames = (Array.isArray(locationsOfReports) ? locationsOfReports : []).reduce((acc, item) => {
    if (item && item.report_name) {
      const values = String(item.tab_name || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      acc[item.report_name] = values;
    }
    return acc;
  }, {});
  if (!reportIdToTabNames[INVENTORY_LEDGER]) {
    reportIdToTabNames[INVENTORY_LEDGER] = ['fulfillment'];
  }
  if (!reportIdToTabNames[AMAZON_FBA_TRANSFER_LEDGER]) {
    reportIdToTabNames[AMAZON_FBA_TRANSFER_LEDGER] = ['finance', 'fulfillment'];
  }
  if (!reportIdToTabNames[AMAZON_FBA_TRANSFER_HISTORY]) {
    reportIdToTabNames[AMAZON_FBA_TRANSFER_HISTORY] = ['finance', 'fulfillment'];
  }
  if (!reportIdToTabNames[MONTH_END_INVENTORY]) {
    reportIdToTabNames[MONTH_END_INVENTORY] = ['finance'];
  }
  if (!reportIdToTabNames[PICK_PACK_REPORT]) {
    reportIdToTabNames[PICK_PACK_REPORT] = ['fulfillment'];
  }
  if (!reportIdToTabNames[INBOUND_RECEIVING_PUTAWAY]?.length) {
    reportIdToTabNames[INBOUND_RECEIVING_PUTAWAY] = ['fulfillment'];
  }
  reportIdToTabNames[AMAZON_PROFIT_SUMMARY] = ['finance'];
  reportIdToTabNames[AMAZON_PROFIT_BY_SKU_SUMMARY] = ['finance'];

  // Allow all reports if user has access to the Reports child tab; otherwise, only those matching allowed parent tabs
  const hasReportsGlobalAccess = allowedChildIds.has(CHILDREN_TAB_REPORTS) && childIdToAccess.get(CHILDREN_TAB_REPORTS) === 'edit';
  const filteredReportRoutes = (hasReportsGlobalAccess
    ? filteredReports
    : filteredReports.filter((report) => {
        const tabNames = reportIdToTabNames[report.id] || [];
        return tabNames.length > 0 && tabNames.some((name) => allowedParentIds.has(name));
      }))
    .filter((report) => (
      !report.permissionId
      || isAdminRole(currentUser?.role)
      || allowedChildIds.has(report.permissionId)
    ))
    .filter((report) => report.id !== INVENTORY_LEDGER || allowedChildIds.has('inventory-ledger'));

  return (
    <div className="flex min-h-screen">
      {!inApp && !isSignIn && !isLanding && !isDownloadPage && (
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          childrenIdsAccess={allowedChildIds}
          parentIdsAccess={allowedParentIds}
          isMobile={isMobile}
        />
      )}
      <main
        className={`transition-all duration-300`}
        style={mainInlineStyle}
      >
        {inApp && !isSignIn && !isAppHandoff && <InAppBar />}
        <Routes>
          <Route
            path="/"
            element={
              !loading && currentUser ? (
                <Navigate
                  replace
                  to={
                    location.search
                      ? `${ROUTES.SHOPIFY_AMAZON_INVENTORY}${location.search}`
                      : currentUser.role === ROLES.PACKER
                        ? ROUTES.RECEIVED
                        : defaultRedirectPath
                  }
                />
              ) : (
                <Landing />
              )
            }
          />
          <Route path={APP_HANDOFF_PATH} element={<AppHandoff />} />
          <Route
            path="/signin"
            element={
              !loading && currentUser ? (
                <Navigate to={inApp ? appHomePath() : (currentUser.role === ROLES.PACKER ? ROUTES.RECEIVED : defaultRedirectPath)} />
              ) : (
                <SignIn />
              )
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path={ROUTES.DISCONNECT_QB}
            element={
              <DisconnectQB marginFromSidebar={replacedMargin} />
            }
          />
          <Route
            path={ROUTES.QB_REPORT}
            element={
              <QBReport marginFromSidebar={replacedMargin} />
            }
          />
          <Route
            path={ROUTES.RECEIVED_LOG}
            element={
              <ReceivedLog />
            }
          />
          <Route
            path={ROUTES.RECEIVED_SESSIONS}
            element={
              <ReceivedSessions />
            }
          />
          {allowedChildIds.has('location-master') && (
            <Route
              path={ROUTES.WAREHOUSE}
              element={<WarehousePage canEdit={childIdToAccess.get('location-master') === 'edit'} />}
            />
          )}
          {allowedChildIds.has('fba-transfers') && (
            <Route
              path={ROUTES.FBA_TRANSFERS}
              element={<FbaTransfers canEdit={childIdToAccess.get('fba-transfers') === 'edit'} marginFromSidebar={replacedMargin} />}
            />
          )}
          {allowedChildIds.has('amazon-fba-inventory') && (
            <Route path={ROUTES.AMAZON_FBA_INVENTORY} element={<AmazonFbaInventory />} />
          )}
          {allowedChildIds.has('inventory-transfers') && (
            <Route
              path={ROUTES.INVENTORY_TRANSFERS}
              element={<InventoryTransfers canEdit={childIdToAccess.get('inventory-transfers') === 'edit'} />}
            />
          )}
          <Route
            path={ROUTES.RETURNS_RECEIVING}
            element={allowedChildIds.has(CHILDREN_TAB_RETURNS_RECEIVING)
              ? <ReturnsReceiving canEdit={childIdToAccess.get(CHILDREN_TAB_RETURNS_RECEIVING) === 'edit'} />
              : authedRedirect(defaultRedirectPath)}
          />
          <Route path={ROUTES.INVENTORY_LEDGER} element={authedRedirect(ROUTES.REPORTS_INVENTORY_LEDGER)} />
          <Route path={ROUTES.WAREHOUSE_LEGACY} element={authedRedirect(ROUTES.WAREHOUSE)} />
          <Route path={ROUTES.OPEN_TO_BUY} element={authedRedirect(allowedChildIds.has('nav-replenishment-open-to-buy') ? demandPlanningPath('open-to-buy') : defaultRedirectPath)} />
          <Route path={ROUTES.DEMAND_DESTRIBUTION_PROFILE} element={authedRedirect(allowedChildIds.has('nav-demand-distribution-profile') ? demandPlanningPath('demand-distribution-profile') : defaultRedirectPath)} />
          {/* <Route
            path={ROUTES.EFFECTIVE_CAPITAL_SUMMARY}
            element={
              <EffectiveCapitalSummary marginFromSidebar={replacedMargin} />
            }
          /> */}
          <Route 
            path={ROUTES.DUPLICATES} 
            element={
              <DuplicatesReports marginFromSidebar={replacedMargin} />
            } 
          />
          <Route
            path={ROUTES.EXISTED_SKUS}
            element={
              <ExistedSkus marginFromSidebar={replacedMargin} />
            }
          />
          <Route
            path={ROUTES.INACTIVE_SKUS_COMPARISON}
            element={
              <InactiveSkus marginFromSidebar={replacedMargin} />
            }
          />
          <Route
            path={ROUTES.PRINT_SETTINGS}
            element={
              <PrintLabelSettings marginFromSidebar={replacedMargin} />
            }
          />
          <Route
            path={ROUTES.NOTIFICATIONS}
            element={
              <Notifications marginFromSidebar={replacedMargin} />
            }
          />
          <Route
            path="/downloads/:type/:id"
            element={<DownloadPage />}
          />
          <Route
            path="/amazon-raw-inspect"
            element={
              <AmazonRawInspect marginFromSidebar={replacedMargin} />
            }
          />

          {filteredRoutes.map((route) => (
            <Route
              key={`${route.id}-${route.path}`}
              path={route.path}
              element={
                React.createElement(route.Component, {
                  marginFromSidebar: replacedMargin,
                  access: childIdToAccess.get(route.permissionId || route.id),
                  allowedPermissionIds: allowedChildIds,
                  permissionAccess: childIdToAccess,
                })
              }
            />
          ))}

          {filteredReportRoutes.map((route) => (
            <Route
              key={`${route.id}-${route.path}`}
              path={route.path}
              element={
                React.createElement(route.Component, {
                  marginFromSidebar: replacedMargin,
                  canEdit: route.id === INVENTORY_LEDGER && childIdToAccess.get('inventory-ledger') === 'edit',
                  access: isAdminRole(currentUser?.role)
                    ? 'edit'
                    : childIdToAccess.get(route.permissionId || route.id),
                })
              }
            />
          ))}

          {allowedChildIds.has(CHILDREN_TAB_REPORTS) && (
            <Route
              path={ROUTES.REPORTS_CUSTOM}
              element={<CustomReport marginFromSidebar={replacedMargin} />}
            />
          )}

          {/* Only show 404 after auth/locations resolve; otherwise filtered routes are empty and * flashes. */}
          {!loading && currentUser && (
            <Route
              path="*"
              element={
                <NotFoundPage
                  diagnostics={{
                    pathname: location.pathname,
                    search: location.search,
                    authenticated: Boolean(currentUser),
                    userId: currentUser?.id ?? null,
                    role: currentUser?.role ?? null,
                    allowedChildIds: Array.from(allowedChildIds),
                    filteredRouteCount: filteredRoutes.length,
                    filteredReportRouteCount: filteredReportRoutes.length,
                  }}
                />
              }
            />
          )}
        </Routes>
      </main>
    </div>
  );
}

function App() {
  const dispatch = useDispatch();
  const { loading, currentUser } = useSelector((state) => state.auth);
  const {
    locationsOfReports,
    loading: locationsLoading
  } = useSelector((state) => state.reports);

  useEffect(() => {
    // automatically updates the views when a user signs in or out
    if (!currentUser) {
      dispatch(checkAuthStatusAsync())
    }
    dispatch(getLocationsOfReports({}));
    // eslint-disable-next-line
  }, [currentUser]);

  const SMALL_SCREEN_ENDPOINT = 900;
  const [isSidebarOpen, setIsSidebarOpen] = useState();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < SMALL_SCREEN_ENDPOINT);

  useEffect(() => {
    let debounceTimer;
    const handleResize = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const small = window.innerWidth < SMALL_SCREEN_ENDPOINT;
        setIsSmallScreen(small);
        if (small) {
          setIsSidebarOpen(false);
        } else {
          setIsSidebarOpen(true);
        }
      }, 250);
    };

    window.addEventListener('resize', handleResize);
    const storedState = localStorage.getItem('sidebarOpen');
    if (storedState !== null) {
      setIsSidebarOpen(storedState === 'true');
    } else {
      handleResize();
    }

    return () => {
      clearTimeout(debounceTimer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (isSidebarOpen !== undefined) {
      localStorage.setItem('sidebarOpen', isSidebarOpen);
    }
  }, [isSidebarOpen]);

  return (
    <ErrorBoundary>
      <Router>
        <AppContent
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          isSmallScreen={isSmallScreen}
          loading={loading || locationsLoading}
          locationsOfReports={locationsOfReports}
          currentUser={currentUser}
        />
      </Router>
      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        theme="colored"
        transition={Slide}
      />
    </ErrorBoundary>
  );
}

export default App;